module.exports = __webpack_public_path__ + "static/media/NMDC.81d1409f.txt";